import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Search as SearchIcon, ChevronRight, Home as HomeIcon } from 'lucide-react';
import ArticleCard from '../components/ArticleCard';
import Sidebar from '../components/Sidebar';
import { searchArticles, fetchWeather, fetchTrending } from '../services/newsService';
import { AD_SLOTS } from '../mock/mock';

export default function Search() {
  const [params] = useSearchParams();
  const q = params.get('q') || '';
  const [results, setResults] = useState([]);
  const [weather, setWeather] = useState([]);
  const [trending, setTrending] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let m = true;
    setLoading(true);
    Promise.all([searchArticles(q), fetchWeather(), fetchTrending()]).then(([r, w, t]) => {
      if (!m) return;
      setResults(r); setWeather(w); setTrending(t); setLoading(false);
    });
    return () => { m = false; };
  }, [q]);

  return (
    <div className="max-w-[1320px] mx-auto px-4 py-6">
      <nav className="flex items-center gap-1.5 text-[13px] text-[#5b6b63] mb-4">
        <Link to="/" className="inline-flex items-center gap-1 hover:text-[#157347]"><HomeIcon className="w-3.5 h-3.5" />Home</Link>
        <ChevronRight className="w-3.5 h-3.5" /><span className="text-[#157347] font-semibold">Search</span>
      </nav>

      <div className="border-b-2 border-[#157347] pb-4 mb-6">
        <h1 className="font-display font-extrabold text-3xl text-[#0b3d26] inline-flex items-center gap-2"><SearchIcon className="w-7 h-7 text-[#157347]" />Search results</h1>
        <p className="text-[#5b6b63] mt-2">Showing Michigan stories for “<span className="font-semibold text-[#14241d]">{q}</span>”</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2">
          {loading ? (
            <div className="py-16 text-center"><div className="inline-block w-8 h-8 border-2 border-[#157347] border-t-transparent rounded-full animate-spin" /></div>
          ) : results.length === 0 ? (
            <div className="py-16 text-center text-[#5b6b63]">
              <p className="text-lg font-semibold text-[#14241d]">No results found</p>
              <p className="mt-1">Try a different keyword, or browse our sections from the menu.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {results.map((a) => (<ArticleCard key={a.id} article={a} variant="feature" />))}
            </div>
          )}
        </div>
        <div className="lg:col-span-1">
          <Sidebar weather={weather} trending={trending} ads={AD_SLOTS.sidebar} />
        </div>
      </div>
    </div>
  );
}
